import React from "react";
import "./sales-dashboard.css"; // we'll write CSS separately
import { LineChart, PainCard } from "../../components";

const Card = ({ title, children }) => (
    <div className="card">
        <h2 className="card-title">{title}</h2>
        {children}
    </div>
);

const MetricRow = ({ metric, values }) => (
    <tr>
        <td className="metric-name">{metric}</td>
        {values.map((v, i) => (
            <td key={i} className="metric-value">
                {v}
            </td>
        ))}
    </tr>
);

const MetricsTable = ({ columns, rows }) => (
    <div className="metrics-container">
        <div className="metrics-header">
            <h2 className="metrics-title">My Performance - All Metrics</h2>
        </div>
        <table className="metrics-table">
            <thead>
                <tr>
                    <th>Metric</th>
                    {columns.map((c, i) => (
                        <th key={i}>{c}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row, i) => (
                    <MetricRow key={i} metric={row.metric} values={row.values} />
                ))}
            </tbody>
        </table>
    </div>
);

export default function MR_UI({data}) {
    const columns = ["Jan 1 - Jan 7", "Jan 8 - Jan 14", "Jan 15 - Jan 21", "Jan 22 - Jan 28", "Total"];
    const rows = [
        { metric: "Scans", values: [38, 42, 40, 46, 166] },
        { metric: "Number of Users", values: [28, 32, 30, 35, 125] },
        { metric: "Patient Registration", values: [25, 28, 27, 32, 112] },
        { metric: "Doctor Registration", values: [4, 5, 5, 6, 20] },
        { metric: "Back Patients", values: [10, 12, 11, 13, 46] },
        { metric: "Neck Patients", values: [7, 8, 8, 10, 33] },
    ];

    return (
        <div className="dashboard">
    <div className="cards">
                <div className="card">
                    <h2>29.4</h2>
                    <p className="title">Average Patient Registration (Monthly)</p>
                    <p className="target">Monthly Target: 31.5</p>
                    {/* Placeholder for chart */}
                    <div><LineChart data={data?.monthlyUsersCount} /></div>
                </div>

                <PainCard
                    title="Average Patient Registration (Pain Classified) (Monthly)"
                    pain1={data?.mrPainAvg?.pain1Avg}
                    pain2={data?.mrPainAvg?.pain2Avg}
                    overall={data?.mrPainAvg?.overAllPainAvg}
                    target={11.0}
                />
            </div>
            <MetricsTable columns={columns} rows={rows} />
            <div style={{height:"200px"}}></div>
        </div>
    );
}
